import { ECacheTime } from '@/lib/config/enum'
import { __cAccountService } from '@/services/client/__c.account.service'
import { useQuery } from '@tanstack/react-query'
import { useUserQuery } from '../user/use-user'

export function useReferFriendQuery() {
  const { data: user } = useUserQuery()

  return useQuery({
    queryKey: ['query.refer-friend'],
    queryFn: async () => {
      const response = await __cAccountService.getIndexReferFriend()
      return response.data
    },
    staleTime: ECacheTime.THREE_HOURS,
    notifyOnChangeProps: 'all',
    enabled: !!user?.id,
  })
}
